import * as THREE from 'three';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';

const BTC_ORANGE = 0xF7931A;

const BTC_SVG_PATH = 'M217.021,167.042c18.631-9.483,30.288-26.184,27.565-54.007c-3.667-38.023-36.526-50.773-78.006-54.404l-0.008-52.741h-32.139l-0.009,51.354c-8.456,0-17.076,0.166-25.657,0.338L108.76,5.897l-32.11-0.003l-0.006,52.728c-6.959,0.142-13.793,0.277-20.466,0.277v-0.156l-44.33-0.018l0.006,34.282c0,0,23.734-0.446,23.343-0.013c13.013,0.009,17.262,7.559,18.484,14.076l0.01,60.083v84.397c-0.573,4.09-2.984,10.625-12.083,10.637c0.414,0.364-23.379-0.004-23.379-0.004l-6.375,38.335h41.817c7.792,0.009,15.448,0.13,22.959,0.19l0.028,53.338l32.102,0.009l-0.009-52.779c8.832,0.18,17.357,0.258,25.684,0.247l-0.009,52.532h32.138l0.018-53.249c54.022-3.1,91.842-16.697,96.544-67.385C266.916,192.612,247.692,174.396,217.021,167.042z M109.535,95.321c18.126,0,75.132-5.767,75.14,32.064c-0.008,36.269-56.996,32.032-75.14,32.032V95.321z M109.521,262.447l0.014-70.672c21.778-0.006,90.085-6.261,90.094,35.32C199.638,266.971,131.313,262.431,109.521,262.447z';

export const createBitcoinLogo = () => {
  const group = new THREE.Group();
  const geometries = [];
  const materials = [];

  const loader = new SVGLoader();
  const paths = loader.parse(
    `<svg viewBox="0 0 273.6 360"><path d="${BTC_SVG_PATH}"/></svg>`
  ).paths;

  const frontMat = new THREE.MeshStandardMaterial({
    color: BTC_ORANGE,
    emissive: BTC_ORANGE,
    emissiveIntensity: 0.25,
    roughness: 0.2,
    metalness: 0.7,
    side: THREE.DoubleSide,
  });
  materials.push(frontMat);

  const extrudeSettings = {
    depth: 12,
    bevelEnabled: true,
    bevelThickness: 3,
    bevelSize: 3,
    bevelSegments: 3,
  };

  paths.forEach(path => {
    const shapes = SVGLoader.createShapes(path);
    shapes.forEach(shape => {
      const geo = new THREE.ExtrudeGeometry(shape, extrudeSettings);
      geometries.push(geo);
      const mesh = new THREE.Mesh(geo, frontMat);
      group.add(mesh);
    });
  });

  const box = new THREE.Box3().setFromObject(group);
  const size = new THREE.Vector3();
  const center = new THREE.Vector3();
  box.getSize(size);
  box.getCenter(center);

  const maxDim = Math.max(size.x, size.y, size.z);
  const scale = 0.7 / maxDim;

  group.position.set(-center.x * scale, center.y * scale, -center.z * scale);
  group.scale.set(scale, -scale, scale);

  const pivot = new THREE.Group();
  pivot.add(group);

  const cleanup = () => {
    geometries.forEach(g => g.dispose());
    materials.forEach(m => m.dispose());
  };

  return { mesh: pivot, dispose: cleanup };
};
